// extracted by mini-css-extract-plugin
export default {"audio_tag":"e22549","audio":"ce6c17","time":"e154e9","sound_range":"cae029","download_button":"a3d9e7"};